export default [
  {
    path: "/",
    redirect: window.VITE_APP_LOGIN_PAGE || import.meta.env.VITE_APP_LOGIN_PAGE
  },
  {
    path: "/login",
    meta: {
      title: (window._globalConfig?.rootNodeName || import.meta.env.VITE_APP_TITLE) + "-sso登录",
      analyticsIgnore: true
    },
    component: () => import("@/views/login/login.vue")
  },
  {
    path: import.meta.env.VITE_APP_ACCOUNT_LOGIN_PAGE,
    meta: {
      title: (window._globalConfig?.rootNodeName || import.meta.env.VITE_APP_TITLE) + "-登录",
      analyticsIgnore: true
    },
    component: () => import("@/views/login/CTFLogin.vue")
  },

  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/error/404.vue")
  }
];
